import { render, staticRenderFns } from "./loginCallBack.vue?vue&type=template&id=fb328dac&scoped=true&"
import script from "./loginCallBack.vue?vue&type=script&lang=js&"
export * from "./loginCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb328dac",
  null
  
)

export default component.exports